import { render } from "./StatsView.vue?vue&type=template&id=87a0942c"
import script from "./StatsView.vue?vue&type=script&lang=js"
export * from "./StatsView.vue?vue&type=script&lang=js"

import "./StatsView.vue?vue&type=style&index=0&id=87a0942c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/StatsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87a0942c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87a0942c', __exports__)) {
    api.reload('87a0942c', __exports__)
  }
  
  module.hot.accept("./StatsView.vue?vue&type=template&id=87a0942c", () => {
    api.rerender('87a0942c', render)
  })

}


export default __exports__